import {
    UserDashpoardPage,
    UserAllCases,
    UserCaseDetails,
    UserAllPleadings,
    UserPleadingDetails
} from "../pages/UserDashboard"

export const UserRoutes = [

    {path: "/userdashboard", element: <UserDashpoardPage />},
    {path: "/userAllCases", element: <UserAllCases />},
    {path: "/userCaseDetails/:id", element: <UserCaseDetails />},
    {path: "/userAllPleadings", element: <UserAllPleadings />},
    {path: "/userPleadingsDetails/:id",element:<UserPleadingDetails/>}
]